import { IconProps } from './common';

const Tail = (props: IconProps) => (
  <svg
    {...props}
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.978516 8.12346V0.926252C1.23968 0.895557 1.62299 0.867287 2.10043 0.879495C3.05964 0.904022 4.396 1.09179 5.88671 1.74959C6.8735 2.18502 7.9058 2.96591 8.85325 3.83423C9.79093 4.6936 10.6198 5.61456 11.2072 6.31152C11.2048 6.31372 11.2026 6.31517 11.2011 6.31588C11.2001 6.31631 11.1995 6.31648 11.1987 6.31658C11.1981 6.31665 11.1948 6.31703 11.1881 6.3157C9.86916 6.05674 7.81092 5.75713 6.02987 5.96764C4.52519 6.14549 3.05159 6.84933 1.97727 7.48423C1.59378 7.71086 1.25564 7.93205 0.978516 8.12346Z"
      fill="#32373E"
      stroke="#32373E"
    />
  </svg>
);

export default Tail;
